import { getLocale } from "../runtime";

const sv_usp2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Gratis rådgivning`
};

const usp2 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_usp2(inputs)
	return "usp2";
};

export { usp2 as "usp2" };